import { useTranslation } from "react-i18next";

import ActionButtonLayout from "../layout/ActionButtonLayout";

/**
 * @COMPONENT_NAME CustomButtonLayout
 * @DESCRIPTION 다국어 버튼명을 포함한 액션 버튼 레이아웃 컴포넌트.
 *              전달받은 buttonName을 i18n 번역 후 ActionButtonLayout의 자식으로 렌더링합니다.
 *
 * @PROPS
 *   - {string} buttonName - 버튼에 표시할 다국어 키 값
 *   - {...any} others - ActionButtonLayout에 전달될 기타 props
 *
 * @PASSTHROUGH_PROPS
 *   - {any} * - 모든 props는 ActionButtonLayout으로 전달됩니다.
 *
 * @CALLBACKS 없음
 *
 * @EXAMPLES
 * ```jsx
 * <CustomButtonLayout buttonName="action.save" onClick={() => saveSomething()} />
 * ```
 */


function CustomButtonLayout ( props ) {

    const { buttonName } = props;
    
    const { t } = useTranslation();

    return <ActionButtonLayout {...props}>{t(buttonName)}</ActionButtonLayout>;

}

export default CustomButtonLayout;

